module.exports = __webpack_public_path__ + "images/emoji/mute.ed368ffb21583e7a1ca1.png";